require('core-js/stable');
require('regenerator-runtime/runtime');
// @link {参考 | https://github.com/andyearnshaw/Intl.js#intljs-and-browserifywebpack}
require('intl');
require('intl/locale-data/jsonp/en');
